import React, { useEffect, useMemo, useState } from 'react'
import Layout from '../../brands/components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import AddHoliday from '../components/AddHolidayModal'
import { Holidays } from '../types'
import { dateFormat } from '../utils'
import EditHoliday from '../components/EditHolidayModal'
import DeleteHoliday from '../components/DeleteHolidayModal'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
// import { getAllHolidays } from '../slice/holidayslice'
import CustomPagination from '../../../components/Pagination'
import { Search } from '../../../components'
import { SortColumn } from '../../brands/type'
import { getComparator } from '../../../utils'
import { getAllHolidays } from '../api'
import { holidaylist } from '../slice/holidayslice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'

const Holiday: React.FC = () => {
    const { holidayList, totalCount, pageSize } = useAppSelector(
        (state) => state.holidays
    )
    const holidayState = useAppSelector((state) => state.holidays)
    const dispatch = useAppDispatch()
    const [seletedBrand, setSelectedBrand] = useState<Holidays | null>(null)
    const [showAddHolidayModal, setShowAddHolidayModal] =
        useState<boolean>(false)
    const [showEditHolidayModal, setEditHolidayModal] = useState<boolean>(false)
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [sortColumns, setSortColumns] = useState<readonly SortColumn[]>([])
    const [search, setSearch] = useState<string>('')
    const totalPages = Math.ceil(totalCount / pageSize)

    const column = [
        {
            key: 'title',
            name: 'Holiday Name',
            resizable: true,
            sortable: true,
            frozen: true,
        },
        {
            key: 'holidayDate',
            name: 'Date',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return <>{dateFormat(props.row.holidayDate)}</>
            },
        },
        {
            key: 'holidayDay',
            name: 'Day',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return <>{props.row.holidayDay}</>
            },
        },
        {
            key: 'actions',
            name: 'Actions', // Fix the typo here
            resizable: true,
            sortable: true,
            renderCell: () => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            onClick={() => {
                                setEditHolidayModal(true)
                            }}
                            icon="bx:edit"
                            className="icon-primary"
                            cursor={'pointer'}
                        />
                        <Icon
                            onClick={() => {
                                setShowDeleteModal(true)
                            }}
                            icon="icon-park-outline:delete"
                            className="icon-secondary"
                            cursor={'pointer'}
                        />
                    </div>
                </>
            ),
        },
    ]

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const fetchData = async () => {
            try {
                // Call the asynchronous function and wait for its result
                const holidaysData = await getAllHolidays({
                    search: search,
                    currentPage: currentPage,
                    recordsPerPage: 10,
                })

                // Dispatch the action with the data if needed
                dispatch(
                    holidaylist({
                        data: holidaysData.data,
                        totalCount: holidaysData.data.totalCount,
                        pageSize: holidaysData.data.pageSize,
                    })
                )
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching holidays:', err)
            }
        }

        // Call the function to fetch data
        fetchData()
    }, [currentPage, search])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }

    const getValue = (value: string) => {
        setSearch(value)
    }

    const sortedRows = useMemo(() => {
        if (sortColumns.length === 0) return holidayList

        return [...holidayList].sort((a: Holidays, b: Holidays) => {
            for (const sort of sortColumns) {
                const comparator: any = getComparator(sort.columnKey)
                const compResult = comparator(a, b)
                if (compResult !== 0) {
                    return sort.direction === 'ASC' ? compResult : -compResult
                }
            }
            return 0
        })
    }, [holidayList, sortColumns, holidayState])

    return (
        <div>
            <AddHoliday
                show={showAddHolidayModal}
                onClose={setShowAddHolidayModal}
            />
            <EditHoliday
                show={showEditHolidayModal}
                onClose={setEditHolidayModal}
                data={seletedBrand || { title: '', holidayDate: '', id: '' }}
            />
            <DeleteHoliday
                show={showDeleteModal}
                onClose={setShowDeleteModal}
                data={seletedBrand || { title: '', id: '' }}
            />
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Holiday Management</h4>
                            </div>
                            <div className="col-sm-6">
                                <div className="custom-btn-design">
                                    <a
                                        onClick={() => {
                                            setShowAddHolidayModal(true)
                                        }}
                                        className="button button-primary button-align-right"
                                    >
                                        ADD NEW HOLIDAY
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <Search
                            placeholder="Search Holiday"
                            onSearch={getValue}
                        />
                    </div>
                    {holidayList?.length > 0 ? (
                        <>
                            <DataGrid
                                className="data-grid-table"
                                columns={column}
                                rowKeyGetter={(row: Holidays) => row.id}
                                rows={sortedRows}
                                onCellClick={(row) => {
                                    setSelectedBrand(row.row)
                                }}
                                sortColumns={sortColumns}
                                onSortColumnsChange={setSortColumns}
                                rowHeight={60}
                                headerRowHeight={40}
                            />
                        </>
                    ) : (
                        <div className="no-records">No records found</div>
                    )}
                    {holidayList?.length >= 1 && (
                        <div className="mt-2">
                            <CustomPagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                getPageNumber={getCurrentPage}
                            />
                        </div>
                    )}
                </div>
            </Layout>
        </div>
    )
}

export default Holiday
